import React, { useState, useEffect } from 'react';

const CopyAvailabilityModal = ({ sourceDate, instructorId, onClose, onConfirm }) => {
  const [numberOfWeeks, setNumberOfWeeks] = useState(4);
  const [previewDates, setPreviewDates] = useState([]);

  useEffect(() => {
    // Calculate preview dates
    const dates = [];
    const sourceDateTime = new Date(sourceDate + 'T00:00:00');
    
    for (let week = 1; week <= numberOfWeeks; week++) {
      const targetDate = new Date(sourceDateTime);
      targetDate.setDate(targetDate.getDate() + (week * 7));
      dates.push(targetDate.toISOString().split('T')[0]);
    }
    
    setPreviewDates(dates);
  }, [sourceDate, numberOfWeeks]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(numberOfWeeks);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('da-DK', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto',
        padding: '2rem',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
      }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          Copy Availability
        </h2>
        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          Copy availability from <strong>{formatDate(sourceDate)}</strong> to the same weekday for the next X weeks.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Number of Weeks</label>
            <input
              type="number"
              className="form-input"
              value={numberOfWeeks}
              onChange={(e) => setNumberOfWeeks(Math.min(52, Math.max(1, parseInt(e.target.value) || 1)))}
              min="1"
              max="52"
              required
            />
            <p style={{ fontSize: '0.875rem', color: '#666', marginTop: '0.5rem' }}>
              Between 1 and 52 weeks
            </p>
          </div>

          {/* Preview */}
          <div style={{
            background: '#f5f5f5',
            padding: '1rem',
            borderRadius: '8px',
            marginTop: '1.5rem',
            marginBottom: '1.5rem',
            maxHeight: '200px',
            overflowY: 'auto'
          }}>
            <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
              Preview - Dates to be created:
            </h3>
            <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
              {previewDates.map((date, idx) => (
                <li key={idx} style={{ color: '#666', fontSize: '0.9rem', marginBottom: '0.25rem' }}>
                  {formatDate(date)}
                </li>
              ))}
            </ul>
          </div>

          {/* Warning */}
          <div style={{
            background: '#fff3e0',
            border: '1px solid #ff9800',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1.5rem'
          }}>
            <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>
              ℹ️ Dates that already have availability will be skipped automatically.
            </p>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: '0.75rem',
                background: '#e5e5e5',
                color: '#333',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 500
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="cta-button"
              style={{ flex: 1, justifyContent: 'center' }}
            >
              Copy {numberOfWeeks} Week{numberOfWeeks !== 1 ? 's' : ''}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CopyAvailabilityModal;